import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const mailLogin = graphql(
  gql`
    mutation Login($email: String!, $password: String!) {
      login(email: $email, password: $password) {
        user {
          id
          shortId: short_id
          name: first_name
          lastName: last_name
          email
          socialMethod: social_method
          archived
          triggerWelcome: trigger_welcome
        }
        cart
        token
      }
    }
  `,
  {
    name: 'loginWithEmail'
  }
)

export const sendDeprecatedEmailMutation = graphql(
  gql`
    mutation sendDeprecatedEmail($userMail: String!) {
      sendDeprecatedEmail(userMail: $userMail) {
        message
      }
    }
  `,
  {
    name: 'sendDeprecatedEmail'
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/Login/data.ts